<template>
  <main class="mobile-page employee-screen">
    <div class="mobile-screen">
      <header class="mobile-topnav transparent">
        <RouterLink class="mobile-icon-btn solid" to="/mobile/products" aria-label="返回产品全景">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M14.5 5.5 8 12l6.5 6.5" /></svg>
        </RouterLink>
        <span class="mobile-topnav-title compact">{{ selectedProduct?.productName || 'VitaeAI 商品' }}</span>
<!--        <RouterLink class="mobile-icon-btn solid" to="/mobile/download" aria-label="下载 APP">-->
<!--          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 4v10" /><path d="m7.5 10.5 4.5 4.5 4.5-4.5" /><path d="M5 20h14" /></svg>-->
<!--        </RouterLink>-->
        <div></div>
      </header>

      <section class="pd-hero">
        <img class="hero-image" :src="heroImage" :alt="selectedProduct?.productName || 'VitaeAI 商品'" />
        <i class="grid"></i>
        <span class="hud left">AI WORKFORCE</span>
        <span class="hud right">{{ selectedProduct?.productCode || 'PRODUCT' }}</span>
<!--        <i class="bot">-->
<!--          <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#62f4d6" stroke-width="1.5" stroke-linecap="round">-->
<!--            <rect x="5" y="7" width="14" height="11" rx="3.5" /><circle cx="9.4" cy="12.2" r="1.4" fill="#62f4d6" stroke="none" /><circle cx="14.6" cy="12.2" r="1.4" fill="#62f4d6" stroke="none" /><path d="M9.5 15.6h5" /><path d="M12 7V4.2" /><circle cx="12" cy="3.2" r="1.1" fill="#62f4d6" stroke="none" /><path d="M5 10.5H3.4M20.6 10.5H19" opacity=".6" />-->
<!--          </svg>-->
<!--        </i>-->
      </section>

      <div class="pd-price-row">
        <strong>{{ priceText }}</strong>
        <span>{{ [selectedProduct?.formText, selectedProduct?.servicePeriod, freightText].filter(Boolean).join(' · ') }}</span>
      </div>
      <h1>{{ selectedProduct?.productName || '官方商品信息' }}</h1>
      <p class="pd-sub">{{ selectedProduct?.subtitle || productSummary || '正在读取官方商品配置...' }}</p>
      <p v-if="selectedProduct?.description" class="pd-sub">{{ selectedProduct.description }}</p>
      <p v-if="selectedProduct?.formText" class="pd-sub">{{ selectedProduct.formText }}</p>
      <div class="ptags payment-tags">
        <span v-for="method in selectedProduct?.allowedPaymentMethods || []" :key="method">
          支持{{ paymentMethodText(method) }}
        </span>
      </div>

      <div class="metric3">
        <div v-for="metric in productMetrics" :key="metric.label">
          <strong>{{ metric.value }}</strong>
          <span>{{ metric.label }}</span>
        </div>
      </div>

      <div v-if="productConfigLoading && !productConfigLoaded" class="mobile-card config-state">正在读取官方商品配置...</div>
      <div v-else-if="productConfigError && !productConfigLoaded" class="mobile-card config-state error">
        <p>{{ productConfigError }}</p>
        <button class="mobile-btn mobile-btn-ghost" type="button" @click="loadProductConfig(true)">重新加载</button>
      </div>
      <div v-else-if="!selectedProduct" class="mobile-card config-state error">
        <p>商品不存在或已停用，请返回商品列表重新选择。</p>
        <RouterLink class="mobile-btn mobile-btn-ghost" to="/mobile/products">返回商品列表</RouterLink>
      </div>

      <div class="mobile-card">
        <span class="mobile-eyebrow title">Workflow · 三步增长闭环</span>
        <div class="workflow">
          <div v-for="step in workflows" :key="step.no" class="wf-step">
            <i class="wf-no">{{ step.no }}</i>
            <div><strong>{{ step.title }}</strong><p>{{ step.text }}</p></div>
          </div>
        </div>
      </div>

      <div class="mobile-card">
        <span class="mobile-eyebrow title">Includes · 套餐包含</span>
        <div v-for="item in productIncludes" :key="item" class="inc-row">
          <i class="inc-check"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.6" stroke-linecap="round"><path d="M4.5 12.5 10 18 19.5 7" /></svg></i>
          <span>{{ item }}</span>
        </div>
        <p v-if="productConfigLoaded && !productIncludes.length" class="empty-includes">后台暂未配置包含内容。</p>
      </div>

      <div class="mobile-card">
        <span class="mobile-eyebrow title">Capability · 核心能力</span>
        <div class="ptags"><span v-for="tag in capabilities" :key="tag">{{ tag }}</span></div>
      </div>

      <div class="dock">
        <div>
          <small>应付总额 · {{ freightText }}</small>
          <strong>{{ totalText }}</strong>
        </div>
        <button
          class="mobile-btn mobile-btn-primary"
          type="button"
          :disabled="!productConfigLoaded || !selectedProduct || productConfig.orderEnabled !== true"
          @click="goOrder"
        >
          {{ productConfig.orderEnabled === true ? '立即下单' : '暂未开放下单' }}
        </button>
      </div>
    </div>
    <MobileTabbar active="vitaeai" />
    <MobileServiceFloating raised />
  </main>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MobileTabbar from '@/components/mobile/MobileTabbar.vue'
import MobileServiceFloating from '@/components/mobile/MobileServiceFloating.vue'
import { paymentMethodText, useWebsiteProductConfig } from '@/composables/useWebsiteProductConfig'

const route = useRoute()
const router = useRouter()
const {
  productConfig,
  selectedProduct,
  productConfigLoading,
  productConfigLoaded,
  productConfigError,
  loadProductConfig,
  selectProduct,
  priceText,
  freightText,
  productSummary,
  productIncludes,
  productMetrics
} = useWebsiteProductConfig()

const heroImage = computed(() => {
  const code = String(selectedProduct.value?.productCode || '').toUpperCase()
  if (code.includes('GEO')) return '/images/pexels-content-timeline.jpg'
  if (code.includes('CUSTOMER')) return '/images/pexels-growth-dashboard.jpg'
  if (code.includes('CITY_PARTNER')) return '/images/pexels-private-ops-laptop.jpg'
  return '/images/pexels-humanoid-robot.jpg'
})

const totalText = computed(() => {
  if (productConfig.value.priceHidden === true || !selectedProduct.value) return '价格以确认订单为准'
  return `¥${(Number(selectedProduct.value.unitPrice || 0) + Number(selectedProduct.value.freightAmount || 0))
    .toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
})

const workflows = [
  { no: '01', title: 'AI 内容工厂', text: '围绕企业需求与用户画像生成文案、图像、短视频等内容，持续积累品牌内容资产。' },
  { no: '02', title: '精准触达与引流', text: '基于目标用户特征规划触达与互动，让品牌内容更有效地连接潜在客户。' },
  { no: '03', title: '私域承接与转化', text: '通过知识库问答、需求识别和个性化推荐，持续服务客户并促进转化复购。' }
]
const capabilities = ['AI 员工矩阵', '内容创作', '公域曝光', '私域经营', '客户触达', '自动化转化']

/**
 * 携带商品编码进入移动下单页。
 */
function goOrder() {
  if (productConfig.value.orderEnabled !== true || !selectedProduct.value) return
  router.push({ path: '/mobile/order', query: { productCode: selectedProduct.value.productCode } })
}

onMounted(() => {
  selectProduct(route.params.productCode)
  loadProductConfig().catch(() => {})
})

watch(() => route.params.productCode, productCode => {
  selectProduct(productCode)
})
</script>

<style scoped>
.employee-screen { padding-bottom: calc(72px + env(safe-area-inset-bottom)); }
.mobile-topnav.transparent { background: none; backdrop-filter: none; }
.mobile-topnav-title.compact { font-size: 13px; }
.mobile-icon-btn.solid { background: rgba(5,12,24,.7); }
.pd-hero { height: 210px; position: relative; display: flex; align-items: center; justify-content: center; margin: 0 -18px; background: radial-gradient(200px 130px at 50% 100%, rgba(98,244,214,.3), transparent 72%), linear-gradient(160deg,#0e2338,#0a1730 55%,#060e1d); }
.hero-image { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; filter:saturate(1.08) contrast(1.05); }
.pd-hero::after { content:""; position:absolute; inset:0; z-index:1; background:linear-gradient(180deg,rgba(2,5,13,.16),rgba(2,5,13,.76)); }
.grid { position: absolute; inset: 0; background-image: linear-gradient(rgba(222,246,255,.055) 1px,transparent 1px),linear-gradient(90deg,rgba(222,246,255,.055) 1px,transparent 1px); background-size: 24px 24px; mask-image: radial-gradient(circle at 50% 60%,#000 0 30%,transparent 78%); }
.hud { position: absolute; top: 18px; z-index: 2; color: rgba(98,244,214,.75); font-size: 9px; font-weight: 800; letter-spacing: .22em; }
.hud.left { left: 20px; }.hud.right { right: 20px; color: rgba(255,207,106,.7); }
.bot { position: relative; z-index: 2; width: 84px; height: 84px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(98,244,214,.45); border-radius: 24px; background: rgba(5,14,26,.8); box-shadow: 0 0 44px rgba(98,244,214,.4); }
.pd-price-row { display: flex; align-items: baseline; gap: 10px; margin: 16px 2px 4px; }
.pd-price-row strong { color: var(--mobile-cyan); font-size: 30px; font-weight: 900; letter-spacing: .01em; }
.pd-price-row span { color: var(--mobile-quiet); font-size: 11px; font-weight: 700; }
h1 { margin: 2px 2px 8px; font-size: 19px; font-weight: 900; }
.pd-sub { margin: 0 2px 16px; color: var(--mobile-muted); font-size: 12px; line-height: 1.65; }
.payment-tags { margin: -6px 2px 16px; }
.metric3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 8px; }
.metric3 div { position: relative; overflow: hidden; padding: 12px 8px; border: 1px solid var(--mobile-line); border-radius: 12px; text-align: center; background: linear-gradient(180deg,rgba(98,244,214,.07),rgba(255,255,255,.015)); }
.metric3 div::before { content:""; position:absolute; top:0; right:20%; left:20%; height:1.5px; background:linear-gradient(90deg,transparent,rgba(98,244,214,.6),transparent); }
.metric3 strong { display:block; color:var(--mobile-cyan); font-size:13px; font-weight:900; }
.metric3 span { display:block; margin-top:3px; color:var(--mobile-quiet); font-size:10px; font-weight:600; }
.mobile-card { margin-top: 14px; }.mobile-card:first-of-type { margin-top: 14px; }
.title { margin-bottom: 10px; }
.workflow { display:flex; flex-direction:column; }.wf-step { position:relative; display:flex; gap:12px; padding-bottom:16px; }.wf-step:last-child{padding-bottom:0}.wf-step::before{content:"";position:absolute;top:34px;bottom:2px;left:15px;width:1px;background:linear-gradient(180deg,rgba(98,244,214,.4),rgba(98,244,214,.08))}.wf-step:last-child::before{display:none}.wf-no{width:31px;height:31px;flex:0 0 31px;display:flex;align-items:center;justify-content:center;border:1.5px solid rgba(98,244,214,.5);border-radius:50%;color:var(--mobile-cyan);font-size:11px;font-weight:900;background:rgba(98,244,214,.08);font-style:normal}.wf-step strong{display:block;margin-bottom:3px;font-size:13.5px;font-weight:800}.wf-step p{color:var(--mobile-quiet);font-size:11px;line-height:1.6}
.inc-row{display:flex;align-items:center;gap:10px;padding:9px 0;border-bottom:1px dashed rgba(222,246,255,.1)}.inc-row:last-child{border-bottom:none;padding-bottom:2px}.inc-check{width:18px;height:18px;flex:0 0 18px;display:flex;align-items:center;justify-content:center;border-radius:50%;color:var(--mobile-cyan);background:rgba(98,244,214,.14);font-style:normal}.inc-row span{color:var(--mobile-muted);font-size:12.5px;font-weight:600}.inc-row b{margin-left:auto;color:var(--mobile-ink);font-size:12.5px;font-weight:800}.inc-row b.gold{color:var(--mobile-gold)}
.config-state{display:grid;gap:12px;justify-items:center;color:var(--mobile-muted);font-size:12.5px;text-align:center}.config-state.error{color:#ff9c9c}.config-state .mobile-btn{width:100%}
.empty-includes{padding:9px 0 2px;color:var(--mobile-quiet);font-size:12px}
.ptags{display:flex;flex-wrap:wrap;gap:6px;margin-top:4px}.ptags span{padding:3px 8px;border:1px solid var(--mobile-line-strong);border-radius:6px;color:var(--mobile-muted);font-size:10px;font-weight:700;background:rgba(255,255,255,.03)}.ptags span:nth-child(1){color:#a8f7e4;border-color:rgba(98,244,214,.3);background:rgba(98,244,214,.07)}
.dock{position:sticky;bottom:calc(68px + env(safe-area-inset-bottom));display:flex;align-items:center;gap:12px;margin:18px -18px 0;padding:12px 18px; border-top:1px solid rgba(222,246,255,.16); background:linear-gradient(180deg,rgba(2,5,13,0),rgba(2,5,13,.96) 40%); backdrop-filter:blur(10px)}.dock>div{flex:1;min-width:0}.dock small{display:block;margin-bottom:2px;color:var(--mobile-quiet);font-size:10.5px;font-weight:600}.dock>div>strong{display:block;color:var(--mobile-cyan);font-size:21px;font-weight:900;text-shadow:0 0 22px rgba(98,244,214,.45)}.dock .mobile-btn{flex:0 0 auto;min-width:132px}
</style>
